import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '@utils/response';
import { Token, UserCode, Company, EmployeeId, EmployeeCode } from '@utils/users';
import { GetLanguage } from '@utils/language';
import { errorResponse, okResponse } from '@utils/response';
import * as storage from '@utils/storage';
import { formatDate } from '@utils';
import { encryptPassword } from '@utils';
import { encryption } from '@utils/encryption';

export function addPunch(punchTime, geolocationId, project, activity, department, jobTitle, comments, latitude, longitude, online) {
    comments = comments.trim().length > 0 ? comments.trim() : null;

    return fetch('punch/addPunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            employeeId: EmployeeId(),
            company: Company(),
            ipAddress: 'mob_pc',
            source: '-',
            punchTime: punchTime,
            geolocationId: geolocationId,
            project: project,
            activity: activity.toString(),
            department: department,
            jobTitle: jobTitle,
            comments: comments,
            latitude: latitude,
            longitude: longitude,
            online: online,
            LanguageDescription: GetLanguage(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return response.result;
                }

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function addFilesPunch(param) {
    const params = {};
    params.userCode = UserCode()
    params.punchIdCrypt = param.punchIdEncrypt;
    params.files = param.files;
    params.token = Token();

    return fetch('punch/addFilesPunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function updateFilesPunch(param) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode())
    params.files = param;
    params.token = Token();

    return fetch('punch/updateFilesPunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}
export function getFilesPunch(id) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.punchIdCrypt = encryption(id);
    params.token = Token();

    return fetch('punch/getFilesPunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return JSON.parse(result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function deleteFilePunch(id) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.webDocumentPunchIdCrypt = encryption(id);
    params.token = Token();

    return fetch('punch/deleteFilePunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function activePunch() {
    let url = 'punch/getActivePunch?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let punch = response.punch;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function historyPunch() {
    let url = 'punch/getHistoryPunch?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let punch = response.punch;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function detailPunch(punchId) {
    let url = 'punch/getDetailPunch?' + objectToQueryString({ punchId: punchId, userCode: UserCode(), company: Company(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let detail = response.detail;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function loadCombos(geolocationId, latitude, longitude, useGeolocationAvailable) {
    const timePunch = formatDate(new Date());

    let url = 'punch/combos?' + objectToQueryString(
        {
            company: Company(),
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            employeeId: EmployeeId(),
            geolocationId: geolocationId,
            latitude: latitude !== null ? latitude : 0,
            longitude: longitude !== null ? longitude : 0,
            useGeolocation: storage.getUseGeolocation(),
            useGeolocationZone: storage.getUseGeolocationZone(),
            useGeolocationAvailable: useGeolocationAvailable,
            timePunch: timePunch,
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function confirmAttendance(password, punchId, latitude, longitude) {
    return fetch('punch/confirmAttendance', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            company: Company(),
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            password: encryptPassword(password),
            punchId,
            latitude,
            longitude,
            isSSO: storage.getIsSSO(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function confirmEmergency() {
    return fetch('punch/confirmEmergency', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            company: Company(),
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}